import { CalendarItemType } from '@akin-home/amplify';
import { v4 as uuid } from 'uuid';
import { Alarm } from '../types';

export const createAlarmModel = (input?: Partial<Alarm>): Alarm => ({
  type: CalendarItemType.Alarm,
  checklist: [],

  id: uuid(),
  habitatID: '',
  recurrenceExcludeDates: {},
  title: '',
  start: new Date(),
  updatedAt: new Date().toISOString(),
  createdAt: new Date().toISOString(),

  ...input,
});